import { Descriptions, DescriptionsProps, Image } from 'antd';
import { useEffect, useState } from 'react';

// modals
import { Company } from 'modules/users/models/companies';

// services
import NotificationService from 'core/services/notification';
import { onGetCompanyOverview } from 'modules/users/services/users';
import LoadingComponent from 'components/loadingComponent/loadingComponent';
import { useTranslation } from 'react-i18next';

interface InputProps {
	userId: number;
	company: Company;
}

function CompanyOverviewComponent({ company, userId }: InputProps) {
	const { t } = useTranslation();

	const [isLoading, setIsLoading] = useState(true);

	const [items, setItems] = useState<DescriptionsProps['items']>([]);

	useEffect(() => {
		if (company) {
			getOverView();
		}
	}, [company]);

	const getOverView = async () => {
		try {
			setIsLoading(true);

			const response = await onGetCompanyOverview(userId, company.id);

			const tempItems: DescriptionsProps['items'] = [
				{
					key: 'average_share_price',
					label: t('USERS.AVERAGE_SHARE_PRICE'),
					children: response.data.data.average_share_price,
				},
				{
					key: 'daily_volume',
					label: t('USERS.DAILY_VOLUME'),
					children: response.data.data.daily_volume,
				},
				{
					key: 'daily_value',
					label: t('USERS.DAILY_VALUE'),
					children: response.data.data.daily_value,
				},
				{
					key: 'country',
					label: t('USERS.COUNTRY'),
					children: response.data.data.country,
				},
				{
					key: 'company_manager_name',
					label: t('USERS.COMPANY_MANAGER_NAME'),
					children: response.data.data.company_manager_name,
				},
				{
					key: 'description',
					label: t('USERS.DESCRIPTION'),
					children: response.data.data.description,
				},
			];

			setItems(tempItems);

			setIsLoading(false);
		} catch (error) {
			NotificationService.error(t('COMMON.OPS'), t('COMMON.ERROR_OCCURRED'));
		}
	};

	return (
		<div className="mb-5">
			<div className="d-flex align-items-center gap-4 mt-3">
				<Image src={company.company_logo} width={100} height={100} />
				<div>
					<h2>{company.company_name}</h2>
				</div>
			</div>

			<div className="mt-5">{isLoading ? <LoadingComponent /> : <Descriptions items={items} column={1} />}</div>
		</div>
	);
}

export default CompanyOverviewComponent;
